export default __webpack_public_path__ + "static/media/Clasp of the Fallen Empire.9e128b0b.jpg";